import { createSlice } from "@reduxjs/toolkit";

import { ITeamStore } from "../types";

const initialState: ITeamStore = {
  teams: [],
};

export const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    setTeams: (state, { payload }) => {
      state.teams = payload;
    },
  },
});

export const { setTeams } = teamSlice.actions;
